import React from 'react'

import * as S from './TableCell.styled'
import type { Props } from './types'

export const TableCell = ({
  mainContent,
  additionalContent,
  $bold = false,
  $ellipsis = false,
}: Props) => (
  <S.Container>
    <S.ContentContainer>
      <S.MainContent $bold={$bold} $ellipsis={$ellipsis}>
        {mainContent}
      </S.MainContent>
      {additionalContent && (
        <S.AdditionalContent $ellipsis={$ellipsis}>{additionalContent}</S.AdditionalContent>
      )}
    </S.ContentContainer>
  </S.Container>
)
